export default __webpack_public_path__ + "static/banner_back-6205574843267f5aa8389f5f3f271aa3.webp";